import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent } from "@mui/material";

export default function ConfirmDialog({
  open,
  handleClose,
  onConfirm,
  title,
  message,
  confirmText,
}) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs">
      <DialogContent>
        <Alert severity="warning">
          <AlertTitle>{title}</AlertTitle>
          {message}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>{confirmText}</Button>
      </DialogActions>
    </Dialog>
  );
}
